const  hideValidationMessage = (targetElement)=> {
    targetElement.parentNode.classList.remove("wu-input__error");
    targetElement.parentNode.classList.remove("wu-input--error");
    const targetElementId = targetElement.getAttribute("id");
    const errorEelementDiv = document.querySelector(
      "." + targetElementId + "-error"
    ) || targetElement?.parentNode?.querySelector('.wu-input--error');
    if (errorEelementDiv) {
      errorEelementDiv.classList.add("d-none");
    }
  }

const showValidationMessage = (targetElement, errorMessage)=> {
    targetElement.parentNode.classList.add("wu-input__error");
    targetElement.parentNode.classList.add("wu-input--error");
    const targetElementId = targetElement.getAttribute("id");
    const errorElementDiv = document.querySelector(
        "." + targetElementId + "-error"
    ) || targetElement?.parentNode?.querySelector('.wu-input--error');
    if(errorMessage) {
        errorElementDiv.innerText = errorMessage
    }
    if (errorElementDiv) {
        errorElementDiv.classList.remove("d-none");
    }
}

const showFileValidationMessage = (targetElement, errorAttr) => {
  const parent = targetElement.parentNode
  parent.classList.add("bdr-color-red", "text-alert-dark");
  parent.classList.remove("bdr-color-blue");
  const errorElementDiv = parent.parentElement.querySelector('.wu-input--error')
  if (errorElementDiv) {
      errorElementDiv.classList.remove("d-none");
      errorElementDiv.innerHTML = errorElementDiv.getAttribute(errorAttr)
  }
}

const hideFileValidationMessage = (targetElement) => {
  const parent = targetElement.parentNode
  parent.classList.remove("bdr-color-red", "text-alert-dark");
  parent.classList.add("bdr-color-blue");
  const errorElementDiv = parent.parentElement.querySelector('.wu-input--error')
  if (errorElementDiv) {
      errorElementDiv.classList.add("d-none");
  }
}